export const PURCHASE_CODE_TO_FREE_TRIAL_DAYS: Readonly<Record<string, number>> = { bbzka: 3, wugui: 30 };
